import React from 'react'

import { Avatar, Box, Card, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import { employeeJob } from 'modules/job_catalog/store/collections/roles'
import { employeeLocation } from 'modules/locations/store/collections/locations'

interface Props {
  employee: Employee
  contractVersions: ContractVersions
}

const GeneralInfoBanner: React.FC<Props> = ({ employee, contractVersions }) => {
  const user = employeeUser(employee)
  const avatar = user && user.avatar

  return (
    <Box flexDirection="row" gap="s32" height="s140" width="full">
      <Box
        padding="s32"
        background="grey100"
        gap="s24"
        borderRadius={{
          all: 'abs016',
        }}
        height="full"
        flexDirection="row"
        width="full"
      >
        <Card.Eyebrow>
          <Avatar label="avatar" url={buildUrl(avatar)} size="s80" />
        </Card.Eyebrow>
        <Box gap="s12" justifyContent="center">
          <Text.Header1 weight="bold" color="grey1000" ellipsis>
            {user.fullName()}
          </Text.Header1>
          <Text.Normal size="300" weight="semibold" color="grey800">
            {employeeJob(contractVersions, employee)}
          </Text.Normal>
        </Box>
      </Box>
      <Box
        paddingY="s24"
        paddingX="s48"
        background="grey100"
        gap="s12"
        borderRadius={{
          all: 'abs016',
        }}
        width="full"
        height="full"
      >
        <Box gap="s8" flexDirection="row">
          <Text.Normal color="grey700" weight="semibold">
            {i18n.t('employee_form.email')}
          </Text.Normal>
          <Text.Normal color="grey1000" weight="medium" ellipsis>
            {user.attributes.email}
          </Text.Normal>
        </Box>
        {!!employee.attributes.phone_number && (
          <Box gap="s8" flexDirection="row">
            <Text.Normal color="grey700" weight="semibold">
              {i18n.t('employee_form.phone_number')}
            </Text.Normal>
            <Text.Normal color="grey1000" weight="medium">
              {employee.attributes.phone_number}
            </Text.Normal>
          </Box>
        )}
        <Box gap="s8" flexDirection="row">
          <Text.Normal color="grey700" weight="semibold">
            {i18n.t('common.location')}
          </Text.Normal>
          <Text.Normal color="grey1000" weight="medium" ellipsis lineClamp={1}>
            {employeeLocation(employee.attributes.location_id)?.name}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(GeneralInfoBanner)
